<template>
  <div class="container">
    <div class="info-box df fww">
      <div class="left-box">
        <div class="title df">
          <div class="t1 f1">{{ info.ttar_title }}</div>
          <span class="s1 cup" @click="sourceUrlJump(info.ai_original_url_new)" v-if="info.ai_original_url_new">{{
            $t("原文链接") }}
          </span>
        </div>
        <!-- 作者 -->
        <div class="author-box df aic" v-if="info.ttar_id > 0">
          <span class="author">{{
            info.ttar_type == 10 && info.publisher_info.user_id > 0
              ? info.publisher_info.user_nick_name
              : $t("匿名用户")
          }}</span>
          <span class="date">{{ $t("发表于") }} {{ info.create_time_format_before }}</span>
          <div class="browse">
            <span class="iconfont">&#xe611;</span>
            <span>{{ info.ttar_hits }}</span>
          </div>
          <div class="browse">
            <span>{{ info.ttar_source == 10 ? $t('原创') : $t('转载') }}</span>
          </div>
        </div>
        <!-- 摘要 -->
        <!-- <div class="abstract-box"><span>摘要:</span>{{ info.abstract }}</div> -->
        <!-- 正文 -->
        <div class="text-content clearfix" v-html="info.ttar_content"></div>

        <!-- 点赞收藏分享 -->
        <div class="share-box df jcc" v-show="info.ttar_id > 0">
          <div class="list" :class="info.have_like ? 'activie' : ''" v-throttle="1000"
            @click="handleGive(info.ttar_id)">
            <div class="round df fdc jcc aic">
              <span class="iconfont">&#xe61b;</span>
              <p class="number">{{ info.ttar_likes }}</p>
            </div>
            <el-button type="text" class="pt-0 pb-0 mt-12 mb-0 c-3 lh-20 fs-14" :loading="giveLoading">{{ $t("点赞")
            }}</el-button>
          </div>

          <div class="list" :class="info.have_collection ? 'activie' : ''" v-throttle="1000"
            @click="handleCollection(info.ttar_id)">
            <div class="round df fdc jcc aic">
              <span class="iconfont">&#xe65e;</span>
              <p class="number">{{ info.ttar_collections }}</p>
            </div>
            <el-button type="text" class="pt-0 pb-0 mt-12 mb-0 c-3 lh-20 fs-14" :loading="collectionLoading">{{ $t("收藏")
            }}</el-button>
          </div>

          <div class="bdsharebuttonbox shares-box list">
            <a href="javascript:void(0)" @click="handleShare()" v-throttle="1000" class="bds_more"
              :data-cmd="currentLanguage == 'zh' ? 'more' : ''">
              <div class="shares">
                <div class="round df fdc jcc aic">
                  <span class="iconfont">&#xe61c;</span>
                  <p class="number">{{ info.ttar_share }}</p>
                </div>
                <el-button type="text" class="pt-0 pb-0 mt-12 mb-0 c-3 lh-20 fs-14" :loading="shareLoading">{{ $t("分享")
                }}</el-button>
                <!-- <p class="p1">{{ $t("分享") }}</p> -->
              </div>
            </a>

            <!-- 英文版分享 -->
            <div class="sharewx-link" style="position: absolute" v-if="currentLanguage != 'zh'">
              <div class="bdsharebuttonbox df fdc">
                <a href="#" class="bds_weixin" data-cmd="weixin" title="WeChat">WeChat</a>
                <a href="#" class="bds_linkedin" data-cmd="linkedin" title="linkedin">LinkedIn</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-box">
        <!-- 作者信息 -->
        <div class="author-content" v-if="info.ttar_type == 10 && info.publisher_info.user_id > 0">
          <div class="title">{{ $t("作者信息") }}</div>
          <div class="user-info df aic jcc">
            <div class="avatar cup" @click="(event) => handleaAvatar(event, info.publisher_info)">



              <!-- <el-avatar :size="50" :src="info.publisher_info.user_avatar_att_url" @error="$erroravatarHandler">
                <img src="@/assets/images/avatar.png" alt="" />
              </el-avatar> -->

              <el-image :src="info.publisher_info.user_avatar_att_url" style="width: 50px;height: 50px;">
                <div slot="error" class="image-slot">
                  <img src="@/assets/images/avatar.png" style="width: 50px;height: 50px;" alt="" />
                </div>
              </el-image>


            </div>
            <div class="name">
              {{ info.publisher_info.user_nick_name }}
            </div>
          </div>
          <div class="type-list df aic">
            <div class="li f1">
              <p>{{ $t("文章数") }}</p>
              <span>{{ info.publisher_info.user_topic_article_count }}</span>
            </div>
            <div class="li f1">
              <p>{{ $t("粉丝数") }}</p>
              <span>{{ info.publisher_info.user_fans_count }}</span>
            </div>
            <div class="li f1">
              <p>{{ $t("关注的人") }}</p>
              <span>{{ info.publisher_info.user_follow_count }}</span>
            </div>
          </div>

          <div class="btn-box df">
            <el-button class="btn1 red-btn f1" @click="handleFollow(info.publisher_info.user_id)"
              :loading="followLoading"><span>+</span>{{
                info.publisher_info.have_be_follow == 1
                  ? $t("已关注")
                  : $t("关注")
              }}</el-button>
            <!-- <el-button class="btn2 f1">给TA留言</el-button> -->
          </div>
        </div>
        <div class="author-content" v-else>
          <div class="title">{{ $t("作者信息") }}</div>
          <div class="user-info df aic jcc">
            <div class="avatar">

              <el-avatar :size="50" src="@/assets/images/avatar.png" @error="$erroravatarHandler">
                <img src="@/assets/images/avatar.png" alt="" />
              </el-avatar>
            </div>
            <div class="name">
              {{ $t("匿名用户") }}
            </div>
          </div>
        </div>

        <!-- 相关文章 -->
        <div class="article-box mt-12">
          <div class="title df aic jcsb">
            {{ $t("相关文章") }}
            <el-button type="text" class="btn" @click="refreshRelationList" :loading="refreshLoading"><span
                class="iconfont">&#xe619;</span>{{ $t("换一批") }}</el-button>
          </div>

          <div class="article-boxs">
            <div class="list cup" v-for="(item, index) in relationList" :key="item.ttar_id"
              @click="$navigate('/subject/info', item.ttar_id)">
              <div class="tit1">
                {{ item.ttar_title }}
              </div>
              <div class="type df">
                <div>
                  <span class="iconfont">&#xe611;</span>{{ item.ttar_hits }}
                </div>
                <div class="ml-16">
                  <span class="iconfont">&#xe61b;</span>{{ item.ttar_likes }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TODO:回复start -->

    <template v-if="info.ttar_id > 0">
      <div class="discussbox">
        <div class="discuss-box">
          <div class="container-1752">
            <discuss :id="id" :data="discussData" :userinfo="userinfo" :is_host="is_host"></discuss>
          </div>
        </div>
      </div>

      <el-dialog :title="$t('回复')" :visible.sync="dialogVisible" width="886px" :before-close="closeDialog">
        <div class="df reply-person mb-12">
          <span class="fn mr-16 c-9 fs-14">{{ $t("回复") }}</span>
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入您的回复')"
            v-model="form.ttara_content"></el-input>
        </div>

        <div class="languige-text harmonyos-text" v-if="userinfo.user_expert == 10">
          {{ $t("以实名身份发布") }}
          <el-tooltip :content="$t('以专家身份实名评论后页面会同步展示实名信息')" placement="bottom-start" effect="light">
            <span class="iconfont">&#xe677;</span>
          </el-tooltip>
          <el-checkbox-group v-model="form.is_expert" style="display: inline-block" class="ml-23">
            <el-checkbox :key="10" :label="10">{{ $t("是") }}</el-checkbox>
          </el-checkbox-group>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog" class="btn1">{{
            $t("取消")
          }}</el-button>
          <el-button type="primary" class="btn2" @click="handelSubPer">{{
            $t("确定")
          }}</el-button>
        </span>
      </el-dialog>
    </template>

    <!-- TODO:回复start -->



    <!-- 个人信息 -->
    <avatarTop ref="avatarDialog" @post-submitted="handlePublisherFollow" :id="popUserId"
      :publisherFollowLoading="publisherFollowLoading" />
  </div>
</template>

<script>
// 评论
import discuss from "./components/discuss.vue";
// 接口
import {
  getTopicArticleInfo,
  getTopicArticleInfoRelationList,
  setTopicArticleCollection,
  setTopicArticleLike,
  sharePoints,
  ansList,
} from "@api/subject";
import { getMyInfo, setuserfollowAdd } from "@api/home";

export default {
  components: {
    discuss,
  },
  data() {
    return {

      popUserId: 0, //发布者 弹窗的 用户ID
      dialogVisible: false, //回复弹框
      followLoading: false,
      refreshLoading: false,
      giveLoading: false,
      collectionLoading: false,
      shareLoading: false,
      //发布者关注loading
      publisherFollowLoading: false,
      info: [],
      relationList: [],

      form: {
        ttara_content: "",
        is_expert: [10],
      },
      urlOtherParams: {},
      dataInfo: {},
      userinfo: [],

      // 问题研讨
      discussData: [],
      is_host: 20,
      // 是否是英文版
      currentLanguage: localStorage.getItem("currentLanguage"),
    };
  },

  computed: {
    id() {
      return this.$route.params.id; // 获取路由参数
    },
  },
  mounted() {
    // 设置默认的顶部菜单背景色
    this.$bus.$emit("changeNavbg", "#FAFAFA");
    this.urlOtherParams = this.$route.query;
    this.getData();
  },
  methods: {
    //原文链接 跳转
    sourceUrlJump(url) {
      return window.open(url);
    },
    //获取 初始数据
    async getData(justInfo = false) {
      let res2 = await getTopicArticleInfo({
        id: this.id,
        is_preview: this.urlOtherParams.is_preview ?? 0,
      });
      if (res2.status == 200) {
        this.info = res2.data;
        if (!justInfo) {
          this.getRelationList();
          this.getAnsList();
        }
      }
    },
    // 相关文章
    async getRelationList() {
      let res2 = await getTopicArticleInfoRelationList({
        id: this.info.ttar_id,
      });

      if (res2.status == 200) {
        this.relationList = res2.data;
      }
    },
    // 评论列表
    async getAnsList() {
      let res2 = await ansList({
        id: this.info.ttar_id,
      });

      if (res2.status == 200) {
        this.discussData = res2.data.topic_article_ans_list;
        this.is_host = res2.data.is_host;
      }
    },

    // 换一批 相关文章
    refreshRelationList() {
      this.refreshLoading = true;
      this.getRelationList();
      setTimeout(() => {
        this.refreshLoading = false;
      }, 1000);
    },


    // 头像显示个人信息

    handleaAvatar(event, item) {
      // 判断是否是实名用户
      if (
        item.ttar_type == 20 ||
        item.user_id == 0 ||
        item.user_nick_name == "" ||
        item.user_nick_name == null
      ) {
        return false;
      }
      event.stopPropagation(); // 阻止事件冒泡
      this.$refs.avatarDialog.openModal();
      console.log(212121212121);
      console.log(item);

      this.popUserId = item.user_id;
      console.log(this.id);
    },
    // 关注 弹窗发布者
    async handlePublisherFollow(id) {
      this.publisherFollowLoading = true;
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res.status == 200) {
        this.getData(true);
        this.$message.success(res.msg);
      }
      setTimeout(() => {
        this.publisherFollowLoading = false;
      }, 1000);
    },

    // 关注作者
    async handleFollow(id) {
      this.followLoading = true;
      let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
      if (res.status == 200) {
        this.$message.success(res.msg);
        this.getData(true);
      }
      setTimeout(() => {
        this.followLoading = false;
      }, 1000);
    },

    // 点赞
    async handleGive() {
      this.giveLoading = true;
      let res = await setTopicArticleLike({ ttar_id: this.id });
      this.getData(true);
      setTimeout(() => {
        this.giveLoading = false;
      }, 1000);
    },

    // 收藏
    async handleCollection() {
      this.collectionLoading = true;
      let res = await setTopicArticleCollection({ ttar_id: this.id });
      this.getData(true);
      setTimeout(() => {
        this.collectionLoading = false;
      }, 1000);
    },

    // 分享
    async handleShare() {
      this.shareLoading = true;
      let str = "/cn";
      let Language = localStorage.getItem("currentLanguage"); //获取本地语言
      if (Language && Language != "zh") {
        this.currentLanguage = Language;
      }
      let res = await sharePoints({ id: this.id });
      this.getData(true);
      setTimeout(() => {
        this.shareLoading = false;
      }, 1000);
    },

    // 获取当前用户信息
    async getCurrUserData() {
      let res = await getMyInfo();
      if (res.status == 200) {
        this.userinfo = res.data;
      }
    },

    //关闭回复弹窗
    closeDialog() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.form = {
          ttara_content: "",
          is_expert: [10],
        };
      }, 200);
    },

    //提交评论
    async handelSubPer() {
      if (this.form.taqa_content.replace(/ /g, "") == "") {
        this.$message({
          message: this.$t("请填写正确的回复内容"),
          type: "error",
          customClass: "mt-60", // 添加自定义类
        });
        return false;
      }

      if (this.userinfo.user_expert == 20) this.form.is_expert[0] = 20;
      this.form.is_expert =
        this.form.is_expert.length > 0 ? this.form.is_expert[0] : "";

      // 立即提问
      let res = await setactQuestionAdd({ ...this.form, ttar_id: this.id });
      if (res.status == 200) {
        this.$message({
          message: res.data.msg,
          type: "success",
          customClass: "mt-60", // 添加自定义类
        });
      }

      this.dialogVisible = false;
      this.form = {
        ttara_content: "",
        is_expert: [10],
      };
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
.discuss-box {
  max-width: 1400px;
  margin: 0 auto;
  border-radius: 4px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
  background: rgb(255, 255, 255);
  padding: 28px 40px 156px;
}

.discussbox {
  margin-top: 26px;
  padding-bottom: 36px;
}

.sharewx-link {
  width: 120px;
  background-color: #fff;
  border-radius: 6px;
  padding: 12px;
  box-shadow: 6px 10px 20px rgba(0, 0, 0, 0.2);
  right: -180px;
  bottom: 0;
  opacity: 0;
  visibility: hidden;
  transition: all 0.36s;

  a {
    padding-left: 22px;
    position: relative;
    z-index: 10000;
  }

  a:hover {
    color: #b7251e;
  }
}

.share-box .shares-box:hover {
  .sharewx-link {
    right: -160px;
    bottom: 0;
    opacity: 1;
    visibility: visible;
  }
}

.bdsharebuttonbox {
  position: relative;

  .shares {
    position: absolute;
    left: 0;
    top: 0;
  }

  .bds_more {
    background-image: none;
  }

  a::after {
    width: 52px;
    height: 84px;
    content: "";
    display: inline-block;
    color: #040a16;
    font-size: 16px;
    text-align: left;
    position: absolute;
    left: 0;
    top: 0px;
  }
}

.info-box {
  max-width: 1400px;
  margin: 0 auto;
  padding-top: 14px;

  .share-box {
    margin-top: 120px;

    .list {
      text-align: center;
      margin: 0 20px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover,
      &.activie {
        .p1 {
          color: #1890ff;
        }

        .round {
          color: #1890ff;

          .number,
          .iconfont {
            color: #1890ff;
          }
        }

        ::v-deep(.el-button--text) {
          color: #1890ff !important;
        }
      }

      .round {
        width: 52px;
        height: 52px;
        border-radius: 50%;
        text-align: center;
        box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
        background: rgb(255, 255, 255);

        .iconfont {
          font-size: 16px;
          color: #878787;
        }

        .number {
          font-size: 12px;
          line-height: 12px;
          margin-top: 5px;
          color: #878787;
        }
      }

      .p1 {
        color: rgb(135, 135, 135);
        font-size: 14px;
        line-height: 20px;
        margin-top: 12px;
      }
    }
  }

  .left-box {
    width: calc(100% - 352px);
    border-radius: 4px;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
    background: rgb(255, 255, 255);
    padding: 28px 40px 156px;

    .text-content {
      margin-top: 21px;
      color: #333333;
      line-height: 1.75;

      ::v-deep() {
        table {
          max-width: 100%;
        }

        // td {
        //   border: 1px solid;
        // }

        a {
          color: #0000ee;
          text-decoration: underline;
        }

        i {
          font-style: italic;
        }

        strong {
          font-weight: bold;
        }

        ol,
        ul {
          margin-left: 24px;
        }

        img,
        video {
          max-width: 100%;
          height: auto;
        }
      }
    }

    .abstract-box {
      color: #595959;
      font-size: 14px;
      font-weight: 300;
      line-height: 24px;
      padding-left: 10px;
      position: relative;
      margin-top: 21px;

      &::after {
        content: "";
        display: block;
        width: 2px;
        height: 100%;
        border-radius: 0px 1px 1px 0px;
        position: absolute;
        left: 0;
        top: 0;
        background: linear-gradient(197.15deg,
            rgb(174, 0, 0) 0.013%,
            rgba(255, 255, 255, 0) 161.578%);
      }

      span {
        font-family: "MicrosoftYaHeiSemibold";
      }
    }

    .author-box {
      font-size: 14px;
      line-height: 20px;
      margin-top: 16px;

      .author {
        color: rgb(25, 25, 25);
      }

      .browse {
        font-size: 14px;
        line-height: 14px;
        margin-left: 21px;

        .iconfont {
          margin-right: 3px;
        }
      }

      .date {
        color: rgb(119, 119, 119);
        margin-left: 21px;
      }
    }

    .title {
      .t1 {
        color: rgb(25, 25, 25);
        font-family: "MicrosoftYaHeiSemibold";
        font-size: 26px;
        line-height: 30px;
      }

      .s1 {
        color: rgb(25, 25, 25);
        font-size: 12px;
        line-height: 30px;
        cursor: pointer;

        &:hover {
          color: #b7251e;
        }
      }
    }
  }

  .right-box {
    width: 340px;
    margin-left: 12px;
    height: fit-content;
    position: sticky;
    top: 60px;

    /* 距离顶部的距离 */
    .article-boxs {
      margin-top: 16px;

      .list:hover {
        .tit1 {
          color: #b7251e;
        }
      }

      .tit1 {
        color: rgb(25, 25, 25);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
      }

      .type {
        font-size: 12px;
        line-height: 29px;
        color: #868d9f;

        .iconfont {
          font-size: 13px;
          margin-right: 6px;
          color: #868d9f;
        }
      }
    }

    .article-box {
      .title {
        .btn {
          font-size: 12px;
          border: none;
          padding: 0;
          margin: 0;
        }

        .iconfont {
          font-size: 12px;
          margin-right: 4px;
          color: #b7251e;
        }
      }

    }

    .btn-box {
      padding: 0 12px;
      margin-top: 36px;

      button {
        border-radius: 8px;
        height: 32px;
        padding: 0;
      }

      .btn1 {}

      .btn2 {}
    }

    .type-list {
      text-align: center;
      margin-top: 19px;

      p {
        font-size: 14px;
        color: #858d9e;
        line-height: 18px;
      }

      span {
        font-family: "MicrosoftYaHeiSemibold";
        font-size: 18px;
        color: #040a16;
        line-height: 24px;
        display: inline-block;
        margin-top: 3px;
      }
    }

    .author-content,
    .article-box {
      width: 100%;
      min-height: 271px;
      border-radius: 4px;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.05);
      background: rgb(255, 255, 255);
      padding: 16px;

      .title {
        color: rgb(25, 25, 25);
        font-family: "MicrosoftYaHeiSemibold";
        font-size: 20px;
        line-height: 24px;
      }
    }

    .user-info {
      margin-top: 26px;

      .avatar {
        position: relative;

        ::v-deep() {
          .el-image {
            width: 49px;
            border-radius: 50%;
          }
        }

        &::after {
          content: "";
          display: block;
          width: 56px;
          height: 56px;
          border-radius: 50%;
          border: 1px solid #799eeb;
          position: absolute;
          top: -4px;
          left: -4px;
        }

        &::before {
          content: "";
          display: block;
          width: 64px;
          height: 64px;
          border-radius: 50%;
          border: 1px solid #cadeff;
          position: absolute;
          top: -8px;
          left: -8px;
        }
      }

      .name {
        color: rgb(25, 25, 25);
        font-size: 16px;
        line-height: 24px;
        margin-left: 24px;
      }
    }
  }
}

.container {
  padding: 60px 80px 0;
  min-height: calc(100vh - 280px);
  background: #f9f9f9;
}
</style>